import { FC, useEffect, useState } from 'react'
import { Link, Navigate, useNavigate } from 'react-router-dom'
import IAuth from '../../Interfaces/Auth/IAuth'
import DSAuth from '../../Services/Auth/Auth.Services'
import { useDispatch, useSelector } from 'react-redux'
import DSCatClientes from '../../Services/Catalogos/CatClientes.Services'
import DSCatProveedores from '../../Services/Catalogos/CatProveedores.Services'
import DSCatTipoUnidades from '../../Services/Catalogos/CatTipoUnidades.Services'
import DSCatUbicaciones from '../../Services/Catalogos/CatUbicaciones.Services'
import DSCatServicios from '../../Services/Catalogos/CatServicios.Service'
import { populateCatClientes } from '../../store/features/Catalogos/CatClientesSlice'
import { populateCatProveedores } from '../../store/features/Catalogos/CatProveedoresSlice'
import { populateCatTipoUnidades } from '../../store/features/Catalogos/CatTipoUnidadesSlice'
import { populateCatUbicaciones } from '../../store/features/Catalogos/CatUbicacionesSlice'
import { populateCatServicios } from '../../store/features/Catalogos/CatServiciosSlice'
import { populateUserProfile } from '../../store/features/Auth/UserProfileSlice'
import { populateMenuItems } from '../../store/features/Auth/MenuItemsSlice'
import { RootState } from '../../store/store'
import Leyend from '../../images/leyend.png'
import jwt_decode from 'jwt-decode'

interface IProps {}

export const Login: FC<IProps> = (props) => {
  const navigate = useNavigate()
  const dispatch = useDispatch()
  const UserLogued = useSelector(
    (state: RootState) => state.UserProfile.UserProfile.logueado
  )
  const [Usuario, setUsuario] = useState('')
  const [Contrasena, setContrasena] = useState('')
  const [token, setToken] = useState<string>(
    (window.localStorage.getItem('token')
      ? window.localStorage.getItem('token')
      : '')!
  )
  const [menuStr, setMenuStr] = useState<string>(
    (window.localStorage.getItem('menu')
      ? window.localStorage.getItem('menu')
      : '')!
  )

  const Login = async () => {
    const data: IAuth = {
      usuario: Usuario,
      contrasena: Contrasena,
    }
    DSAuth.login(data)
      .then((response) => {
        localStorage.setItem('token', response.data.token)
        localStorage.setItem('menu', JSON.stringify(response.data.menu))
        setToken(response.data.token)
        localStorage.setItem(
          'tokenInfo',
          JSON.stringify(jwt_decode(response.data.token))
        )
        dispatch(populateMenuItems(response.data.menu))
        dispatch(populateUserProfile(response.data.token))
        navigate('/#/', { replace: true })
      })
      .catch((e: Error) => {
        alert('Credeciales invalidas! ' + e.message.toString())
      })
  }

  const loadCatalogs = () => {
    DSCatClientes.Get()
      .then((response) => {
        dispatch(populateCatClientes(response.data))
      })
      .catch((e: Error) => {})
    DSCatProveedores.Get()
      .then((response) => {
        dispatch(populateCatProveedores(response.data))
      })
      .catch((e: Error) => {})
    DSCatTipoUnidades.Get()
      .then((response) => {
        dispatch(populateCatTipoUnidades(response.data))
      })
      .catch((e: Error) => {})
    DSCatUbicaciones.Get()
      .then((response) => {
        dispatch(populateCatUbicaciones(response.data))
      })
      .catch((e: Error) => {})
    DSCatServicios.Get()
      .then((response) => {
        dispatch(populateCatServicios(response.data))
      })
      .catch((e: Error) => {})
  }

  const validateToken = () => {
    DSAuth.Validate()
      .then((response) => {
        loadCatalogs()
        navigate('/', { replace: true })
      })
      .catch((e: Error) => {
        alert('no valido')
      })
  }

  useEffect(() => {
    if (token.length > 5) {
      validateToken()
    }
  }, [token])

  useEffect(() => {
    if (menuStr) {
      dispatch(populateMenuItems(JSON.parse(menuStr)))
      dispatch(populateUserProfile(token))
    }
  }, [menuStr])

  return (
    <div hidden={token ? true : false}>
      <div className='Auth-form-container'>
        <form className='Auth-form'>
          <div className='Auth-form-content'>
            <h3 className='Auth-form-title'>
              <img src={Leyend} alt='' height='50' />
            </h3>
            <div className='form-group mt-3'>
              <label style={{ color: '#00719F', paddingLeft: '5px' }}>
                Usuario
              </label>
              <input
                type='email'
                className='form-control mt-1'
                placeholder='Usuario'
                onChange={(e) => {
                  setUsuario(e.target.value)
                }}
              />
            </div>
            <div className='form-group mt-3'>
              <label style={{ color: '#00719F' }}>Contraseña</label>
              <input
                type='password'
                className='form-control mt-1'
                placeholder='Contraseña'
                onChange={(e) => {
                  setContrasena(e.target.value)
                }}
              />
            </div>
            <div className='d-grid gap-2 mt-3'>
              <button
                type='button'
                className='btn'
                style={{ backgroundColor: '#00719F', color: '#FFFFFF' }}
                onClick={() => {
                  Login()
                }}
              >
                login
              </button>
            </div>
            <div className='d-grid gap-2 mt-3'>
              <Link to='/reset'>Olvido contraseña</Link>
            </div>
          </div>
        </form>
      </div>
    </div>
  )
}
